import NavigationCtrl from './NavigationCtrl.js';

export default [function () {
    return {
        restrict: 'E',
        controller: NavigationCtrl,
        controllerAs: '$ctrl'
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/navigation/NavDirective.js
// module id = 2009
// module chunks = 0